import { useEffect, useState } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { getLocalToken } from "../services/token";
import { decryptor } from "../services/helper";
import { FaRegUser } from "react-icons/fa";
import { ArrowLeftIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import routes from "../routes";
import CompanyNavbar from "../Components/Navbar/CompanyNavbar";
import BookingDetailPage from "../pages/company/booking-details";

const Company = () => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const openAccordion = (e) => {
    let btn = e.currentTarget;
    let ul = btn.nextSibling;
    let classList = ul.classList;

    if (classList.contains("hidden")) {
      ul.classList.remove("hidden");
      ul.classList.add("flex");
      btn.lastChild.classList.add("rotate-180");
      btn.lastChild.classList.remove("rotate-0");
    } else {
      ul.classList.add("hidden");
      ul.classList.remove("flex");
      btn.lastChild.classList.add("rotate-0");
      btn.lastChild.classList.remove("rotate-180");
    }
  };

  const checkSession = () => {
    try {
      const token = getLocalToken();
      if (!token) navigate("/auth/sign-in");

      let userInfo = decryptor({ encryptedData: token });
      if (!userInfo) navigate("/auth/sign-in");

      if (JSON.parse(userInfo)?.usertype !== "Company")
        navigate("/auth/sign-in");
    } catch (error) {
      console.log(error);
      navigate("/auth/sign-in");
    }
  };

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <main className="h-screen overflow-hidden flex justify-between relative font-nunito">
      {/* SIDEBAR */}
      <div
        className={`${
          sidebarOpen ? "left-0" : "-left-[300px]"
        } absolute top-0 bg-blue-600 w-[300px] flex flex-col transition-all duration-500 z-30`}
      >
        <div className="w-full h-[80px] flex items-center justify-center relative">
          <h1 className="text-xl font-medium text-white flex gap-2">
            <span>
              <FaRegUser />
            </span>
            Partner Panel
          </h1>
          {sidebarOpen && (
            <button
              type="button"
              className="absolute -right-16 top-3 hover:bg-gray-200 bg-white p-3 rounded-full lg:hidden"
              onClick={() => setSidebarOpen(false)}
            >
              <ArrowLeftIcon className="size-7" />
            </button>
          )}
        </div>

        <div className="px-0 pb-2 w-full h-[calc(100vh-80px)]">
          {routes?.map(
            ({ layout, pages }) =>
              layout === "company" && (
                <ul
                  className="flex flex-col gap-2 px-4 size-full overflow-y-auto small-scrollbar"
                  key={layout}
                >
                  {pages.map(({ name, path, subPages, icon }) => (
                    <li className="w-full rounded-sm" key={name}>
                      {subPages && subPages.length > 0 ? (
                        <>
                          <button
                            type="button"
                            className={`bg-transparent text-white hover:bg-[#ffffff33] w-full rounded-md py-2 px-3 hover:text-white text-md  flex justify-between items-center ${
                              subPages
                                .map((e) => `/${layout}${e.path}`)
                                .includes(currentPath)
                                ? "bg-[#ffffff33]"
                                : "bg-transparent"
                            }`}
                            onClick={(e) => openAccordion(e)}
                          >
                            <span className="flex gap-3">
                              {icon && <span>{icon}</span>}
                              <span className="capitalize">{name}</span>
                            </span>
                            <ChevronDownIcon className="size-5 rotate-0" />
                          </button>

                          <ul className="flex-col gap-2 mt-2 px-2 hidden">
                            {subPages.map((item) => (
                              <li
                                className="rounded-sm text-sm"
                                key={item.name}
                              >
                                <Link
                                  className={`text-gray-300 hover:bg-[#ffffff33] flex gap-2 py-2 pl-4 rounded-md items-center ${
                                    `/${layout}${item.path}` !== currentPath
                                      ? "bg-transparent"
                                      : "bg-[#ffffff33]"
                                  }`}
                                  to={`/${layout}${item.path}`}
                                >
                                  {item?.icon && <span>{item?.icon}</span>}
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <Link
                          to={`/${layout}${path}`}
                          className={`text-white hover:bg-[#ffffff33] w-full hover:text-white rounded-md py-2 px-3 text-md  flex gap-3 ${
                            `/${layout}${path}` !== currentPath
                              ? "bg-transparent"
                              : "bg-[#ffffff33]"
                          }`}
                        >
                          {icon && <span>{icon}</span>}
                          <span className="capitalize">
                            {name?.split(".")?.join(" ")}
                          </span>
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              )
          )}
        </div>
      </div>

      {/* MAIN */}
      <div
        className={`${
          sidebarOpen ? "w-[calc(100%-(300px+2px))]" : "w-full"
        } h-screen transition-all duration-500 ease-in-out ml-auto flex flex-col gap-4 pl-3 pt-5 pb-3 bg-blue-100 pr-3`}
      >
        <CompanyNavbar setOpen={setSidebarOpen} />

        <div className="size-full overflow-y-auto small-scrollbar">
          <div className="size-full flex flex-col overflow-x-hidden bg-white pb-4 px-5 rounded-lg">
            <Routes>
              {routes.map(
                ({ layout, pages }) =>
                  layout === "company" &&
                  pages.map(({ path, element }) => {
                    return <Route path={path} element={element} />;
                  })
              )}

              <Route path="/booking/:id" element={<BookingDetailPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Company;
